'use strict';
// Manny approved a 25% reduction on every logo base price on October 13, 2026.
// Detailed artwork requires strictly more than 15 yards at the finished size.
const NeonLogoPricing = (() => {
  const policy = Object.freeze({
    date:'2026-10-13', retailFactor:.75, detailedThresholdFeet:45,
    edges:[24,36,48,60], outdoorMultiplier:1.15,
    rgb:[100,150,200,250], designer:[561.75,786.75,1049.25,1349.25],
    tiers:{
      simple:{label:'Simple outline',prices:[224.25,336.75,449.25,561.75]},
      standard:{label:'Standard logo',prices:[374.25,561.75,749.25,974.25]},
      detailed:{label:'Detailed artwork',prices:[561.75,786.75,1049.25,1349.25]}
    }
  });
  function configure(result,{use='indoor',lighting='solid',rush=false,shipping=0,upgrades=0}={}) {
    if(!['indoor','outdoor'].includes(use)||!['solid','rgb'].includes(lighting)||typeof rush!=='boolean'||![shipping,upgrades].every(n=>Number.isFinite(n)&&n>=0))return {status:'missing',reason:'Choose valid fabrication options.'};
    const indoorBase=result.base,base=use==='outdoor'?Math.round(indoorBase/policy.retailFactor*policy.outdoorMultiplier)*policy.retailFactor:indoorBase;
    const rgb=lighting==='rgb'?policy.rgb[policy.edges.indexOf(result.band)]:0;
    const selectedUpgrades=upgrades+rgb,sign=(base+selectedUpgrades)*(rush?2:1);
    return {...result,indoorBase,base,use,lighting,rgb,upgrades:selectedUpgrades,rush,sign,shipping,total:sign+shipping};
  }
  function designer(input={}) {
    const {width,height}=input;
    if(![width,height].every(n=>Number.isFinite(n)&&n>0))return {status:'missing',reason:'Choose the finished logo size.'};
    const band=policy.edges.findIndex(edge=>Math.max(width,height)<=edge);
    if(band<0)return {status:'review',reason:'Signs over 60 inches on either side need a custom fabrication and shipping quote.'};
    return configure({status:'estimate',band:policy.edges[band],base:policy.designer[band],label:'Designer-finished logo',pricingMode:'designer',needsDesigner:true,feet:null},input);
  }
  function estimate(input = {}) {
    const {width,height,feet,complexity='standard',use='indoor',lighting='solid',rush=false,shipping=0,upgrades=0}=input;
    if(![width,height,feet].every(n=>Number.isFinite(n)&&n>0)||!Object.hasOwn(policy.tiers,complexity)) return {status:'missing',reason:'Enter the finished width, height and measured neon tubing length.'};
    if(![shipping,upgrades].every(n=>Number.isFinite(n)&&n>=0)) return {status:'missing',reason:'Shipping and selected upgrades must be zero or a positive amount.'};
    if(!['indoor','outdoor'].includes(use)||!['solid','rgb'].includes(lighting)||typeof rush!=='boolean') return {status:'missing',reason:'Choose valid fabrication options.'};
    const longest=Math.max(width,height);
    if(longest>60) return {status:'review',reason:'Signs over 60 inches on either side need a custom fabrication and shipping quote.'};
    const tierName=feet>policy.detailedThresholdFeet?'detailed':complexity==='simple'?'simple':'standard';
    const band=policy.edges.findIndex(edge=>longest<=edge),tier=policy.tiers[tierName];
    return configure({status:'estimate',band:policy.edges[band],label:tier.label,complexity:tierName,pricingMode:'fixed-tier',needsDesigner:false,measuredFeet:feet,feet:Math.ceil(feet*4)/4,base:tier.prices[band]},input);
  }
  return Object.freeze({policy,estimate,designer});
})();
if(typeof module!=='undefined')module.exports=NeonLogoPricing;
